module.exports = __webpack_public_path__ + "img/move-num-bg.fc642b1d.png";